import { pageBridge } from './page_bridge'

export function pageEnhance() {
  return {
    beforeCreate(this: any) {
      Object.defineProperties(this, {
        // 重新加载瀑布流
        $reloadWaterfall: {
          value: (name: string, source?: string, clean?: boolean) => {
            return this.$refs[name]?.reload(source, clean)
          },
          enumerable: false,
          writable: false,
          configurable: false,
        },
      })

      const unbind = pageBridge.on('ready', payload => {
        this.pageHeaderHeight = payload.pageHeaderHeight
      })
      this.$once('hook:beforeDestroy', unbind)
    },

    data: () => ({
      pageHeaderHeight: 0,
    }),
  }
}
